import React from "react";
import "./Footer.css"; // create this CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <h1 className="footer-title">#OneSolutions</h1>
    </footer>
  );
};

export default Footer;
